import { useNavigation } from '@speeki/client-admin';

import QuickActionsBackground from '@assets/svgs/QuickActionsBackground.svg';

import { PlaceholderCard } from '@components/atoms/PlaceholderCard/PlaceholderCard';
import { ActionButton } from '@components/molecules/ActionButton/ActionButton';

import { useUserModules } from '@utils/hooks/useUserModules';

import {
    ActionsWrapper,
    HeaderText,
    HeaderWrapper,
    Ornament,
} from './QuickActions.styled';

export const QuickActions = () => {
    const { navigate } = useNavigation();

    const {
        hasDisclosureAccess,
        hasEsgAccess,
        hasIncidentsAccess,
        hasNoQuickActionsAccess,
        hasReportingAccess,
        hasSurveyAccess,
    } = useUserModules();

    if (hasNoQuickActionsAccess) return null;

    return (
        <PlaceholderCard backgroundColor={'secondary'}>
            <Ornament>
                <img alt="Ornament" src={QuickActionsBackground as string} />
            </Ornament>

            <HeaderWrapper>
                <HeaderText>Quick actions</HeaderText>
            </HeaderWrapper>
            <ActionsWrapper>
                {hasEsgAccess && (
                    <ActionButton
                        iconProps={{
                            icon: 'Svg2DChartPie24',
                            size: 24,
                        }}
                        onClick={() =>
                            navigate({
                                path: '/programmes',
                            })
                        }
                        testId="Q5ENZVg"
                    >
                        Manage sustainability programmes
                    </ActionButton>
                )}
                {hasReportingAccess && (
                    <ActionButton
                        iconProps={{
                            icon: 'SvgPulse24',
                            size: 24,
                        }}
                        onClick={() =>
                            navigate({
                                path: '/reporting',
                            })
                        }
                        testId="GkiUzgP"
                    >
                        Generate reports
                    </ActionButton>
                )}
                {hasIncidentsAccess && (
                    <ActionButton
                        iconProps={{
                            icon: 'Svg2DMessaging24',
                            size: 24,
                        }}
                        onClick={() =>
                            navigate({
                                path: '/incidents/dashboard',
                            })
                        }
                        testId="XbfSXDT"
                    >
                        Manage incidents
                    </ActionButton>
                )}
                {hasSurveyAccess && (
                    <ActionButton
                        iconProps={{
                            icon: 'Svg2DSurvey24',
                            size: 24,
                        }}
                        onClick={() =>
                            navigate({
                                path: '/engagement/templates',
                            })
                        }
                        testId="EQSf4Ey"
                    >
                        Send pulse survey
                    </ActionButton>
                )}
                {hasDisclosureAccess && (
                    <ActionButton
                        iconProps={{
                            icon: 'Svg2DDAndD24',
                            size: 24,
                        }}
                        onClick={() =>
                            navigate({
                                path: '/engagement/templates',
                            })
                        }
                        testId="jGJQS2k"
                    >
                        Collect data
                    </ActionButton>
                )}
            </ActionsWrapper>
        </PlaceholderCard>
    );
};
